export const BASE_URL = "https://weighmall.com/kantewale/api/v1/admin/"